/** Scheduled & widely used languages in India (for candidate profiles). English listed first. */
export const INDIAN_LANGUAGES = [
  'English',
  'Assamese',
  'Bengali',
  'Bodo',
  'Dogri',
  'Gujarati',
  'Hindi',
  'Kannada',
  'Kashmiri',
  'Konkani',
  'Maithili',
  'Malayalam',
  'Manipuri',
  'Marathi',
  'Nepali',
  'Odia',
  'Punjabi',
  'Sanskrit',
  'Santali',
  'Sindhi',
  'Tamil',
  'Telugu',
  'Urdu',
  'Bhojpuri',
  'Chhattisgarhi',
  'Rajasthani',
  'Tulu'
];
